module.exports = __webpack_public_path__ + "img/defaulted.0ff6338f.png";